import React, { useState, useEffect  } from "react";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Grid,
  InputAdornment,
  CircularProgress
} from '@mui/material';
import { useNavigate } from "react-router-dom";
import BottomImage from "../../components/LoginPages/bottomimage";
import HeaderApp from "../../components/LoginPages/header";
import "./style.css";
import { esignToolApi } from "../../services/esignApi";

const NewPasswrod = () => {
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const [helperText, setHelperText] = useState({otp: "", password: "", confirmPassword: "" });
  const [errors, setErrors] = useState({otp: "", password: "", confirmPassword: "" });
  const [loading, setLoading] = useState(false);

  const handlePasswordToggle = () => {
    setShowPassword((prev) => !prev);
  }

  const handleConfirmPasswordToggle = () => {
    setShowConfirmPassword((prev) => !prev);
  }

  const validateInputs = () => {
    let newErrors = { otp: "", password: "", confirmPassword: "" };
    let newHelperText = { otp: "", password: "", confirmPassword: "" };
    let isValid = true;
  
    // OTP Validation
    if (!otp) {
      newErrors.otp = "OTP is required";
      newHelperText.otp = "OTP is required";
      isValid = false;
    } else if (!/^\d{6}$/.test(otp)) {
      newErrors.otp = "Invalid OTP";
      newHelperText.otp = "OTP must be exactly 6 digits";
      isValid = false;
    }
  
    // Password Validation
    if (!password.trim()) {
      newErrors.password = "Password is required";
      newHelperText.password = "Password is required";
      isValid = false;
    } else if (password.length < 8) {
      newErrors.password = "Password must be at least 8 characters.";
      newHelperText.password = "Password must be at least 8 characters.";
      isValid = false;
    }
  
    // Confirm Password Validation
    if (!confirmPassword.trim()) {
      newErrors.confirmPassword = "Confirm password is required";
      newHelperText.confirmPassword = "Confirm password is required";
      isValid = false;
    } else if (confirmPassword.length < 8) {
      newErrors.confirmPassword = "Confirm password must be at least 8 characters.";
      newHelperText.confirmPassword = "Confirm password must be at least 8 characters.";
      isValid = false;
    } else if (confirmPassword !== password) {
      newErrors.confirmPassword = "Confirm password and Password don't match.";
      newHelperText.confirmPassword = "Confirm password and Password don't match.";
      isValid = false;
    }
  
    setErrors(newErrors);
    setHelperText(newHelperText);
    return isValid;
  };  


  const handleSubmit = async () => {
    if (validateInputs()) {
      setLoading(true);
      try {
          const response = await esignToolApi.verifyOtp(localStorage.getItem('email'), otp);
          console.log(response)
          if (response && response.status===true) {
            const resetResponse = await esignToolApi.setNewPassword(localStorage.getItem('email'), password, otp);
            console.log(resetResponse)
            if (resetResponse.status === true) {
                console.log("Password Reset Successfully");
                localStorage.setItem("newPass", true);
                navigate("/recovery-account");
            } else {
                console.error("Failed to reset password:", resetResponse);
            }
          } else {
              console.error("Failed to verify otp:", response);
          }
      } catch (error) {
          console.error("Error verifyotp:", error);
          setErrors(prev => ({...prev, otp: error?.response?.data?.message || "Invalid OTP"}))
          setHelperText(prev => ({...prev, otp: error?.response?.data?.message || "Invalid OTP"}))
      }  finally {
        setLoading(false); 
      }
    }
  };

  return (
    <>
      <HeaderApp type='login' />
      <Grid container justifyContent="center" alignItems="center" sx={{display: "flex", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 1,  }}>
        <Grid item xs={12} sm={8} md={3.5}>
          <Paper elevation={3} sx={{ padding: "1.6em 3em", display: 'flex', flexDirection: 'column', alignItems: 'center', background:'#fffff', position: 'relative', zIndex: 1, borderRadius: "15px", boxShadow: "rgba(0, 0, 0, 0.1) 0px 7px 49px 0px" }}>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, fontSize: '24px' }}>
                Let me save you!
            </Typography>

            <TextField
              placeholder="OTP"
              name="otp"
              type="number"
              variant="outlined"
              fullWidth
              value={otp}
              onKeyDown={(e) => {
                  if (["e", "E", "+", "-", "."].includes(e.key)) {
                    e.preventDefault();
                  }
              }}
              onPaste={(e) => {
                  const paste = e.clipboardData.getData('text');
                  if (!/^\d+$/.test(paste)) {
                    e.preventDefault();
                  }
              }}
              onChange={(e) => {
                const input = e.target.value;
              
                // Allow only digits and limit to 6 characters
                if (/^\d{0,6}$/.test(input)) {
                  setOtp(input);
                  setErrors((prevErrors) => ({ ...prevErrors, otp: "" }));
                  setHelperText((prevHelperText) => ({ ...prevHelperText, otp: "" }));
                }
              }}
              error={!!errors.otp}
              sx={{
                mt: 2,
                boxSizing: "border-box",
                borderRadius: "10px",
                backgroundColor: "#fff",
                borderColor: "#C0C0C0",
                borderWidth: "5px",
                "& .MuiOutlinedInput-root": {
                  borderColor: errors.otp ? "#FF6666" : "#C0C0C0",
                  backgroundColor: errors.otp ? "#FFF1F1" : "none",
                  "&:hover fieldset": {
                    borderColor: errors.otp ? "#FF6666" : "#C0C0C0",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: errors.otp ? "#FF6666" : "#C0C0C0",
                  },
                },
                "& .MuiFormHelperText-root": {
                  color: "#FF6666",
                },
              }}
              InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <img src={`${process.env.PUBLIC_URL}/images/otp.svg`} alt="Email Icon" style={{ width: 18, height: 18 }} />
                    </InputAdornment>
                ),
                sx: { borderRadius: "10px", height: 45, fontSize: "16px", fontWeight: otp ? "600" : "400" },
              }}
              autoComplete="off"
            />

            {!! errors.otp && (
                <Typography
                sx={{
                    color: "#FF6666",
                    fontSize: "12px",
                    mt: 0.5,
                    mb: 0,
                    marginRight: "auto"
                }}
                >
                {helperText.otp}
                </Typography>
            )}

            <TextField
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              variant="outlined"
              fullWidth
              value={password}
              onChange={(e) => {
                setPassword(e.target.value)
                setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
                setHelperText((prevHelperText) => ({ ...prevHelperText, password: "" }))
            }}
              error={!!errors.password}
              sx={{
                mt: 2,
                boxSizing: "border-box",
                borderRadius: "10px",
                backgroundColor: "#fff",
                borderColor: "#C0C0C0",
                borderWidth: "5px",
                "& .MuiOutlinedInput-root": {
                  borderColor: errors.password ? "#FF6666" : "#C0C0C0",
                  backgroundColor: errors.password ? "#FFF1F1" : "none",
                  "&:hover fieldset": {
                    borderColor: errors.password ? "#FF6666" : "#C0C0C0",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: errors.password ? "#FF6666" : "#C0C0C0",
                  },
                },
                "& .MuiFormHelperText-root": {
                  color: "#FF6666",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={`${process.env.PUBLIC_URL}/images/lock.svg`} alt="Pass Icon" style={{ width: 18, height: 18 }} />
                  </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <Typography
                            onClick={handlePasswordToggle}
                            sx={{
                                cursor: "pointer",
                                color: "#185CB7",
                                fontSize: "15px",
                                fontWeight: 600,
                                transition: "color 0.2s ease-in-out",
                                textDecoration: "none",
                            }}
                            >
                            {showPassword ? "Hide" : "Show"}
                        </Typography>
                    </InputAdornment>
                ),
                sx: { 
                    borderRadius: "10px",
                    height: 45,
                    fontSize: "16px",
                    fontWeight: password ? "600" : "400",
                    "& input::-ms-reveal, & input::-ms-clear": {
                        display: "none",
                    },
                },
              }}
              autoComplete="off"
            />

            {!! errors.password && (
                <Typography
                sx={{
                    color: "#FF6666",
                    fontSize: "12px",
                    mt: 0.5,
                    mb: 0,
                    marginRight: "auto"
                }}
                >
                {helperText.password}
                </Typography>
            )}

            <TextField
              placeholder="Confirm Password"
              type={showConfirmPassword ? "text" : "password"}
              variant="outlined"
              fullWidth
              value={confirmPassword}
              onChange={(e) => {
                setConfirmPassword(e.target.value)
                setErrors((prevErrors) => ({ ...prevErrors, confirmPassword: "" }));
                setHelperText((prevHelperText) => ({ ...prevHelperText, confirmPassword: "" }))
            }}
              error={!!errors.confirmPassword}
              sx={{
                mt: 2,
                boxSizing: "border-box",
                borderRadius: "10px",
                backgroundColor: "#fff",
                borderColor: "#C0C0C0",
                borderWidth: "5px",
                "& .MuiOutlinedInput-root": {
                  borderColor: errors.confirmPassword ? "#FF6666" : "#C0C0C0",
                  backgroundColor: errors.confirmPassword ? "#FFF1F1" : "none",
                  "&:hover fieldset": {
                    borderColor: errors.confirmPassword ? "#FF6666" : "#C0C0C0",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: errors.confirmPassword ? "#FF6666" : "#C0C0C0",
                  },
                },
                "& .MuiFormHelperText-root": {
                  color: "#FF6666",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={`${process.env.PUBLIC_URL}/images/lock.svg`} alt="Pass Icon" style={{ width: 18, height: 18 }} />
                  </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <Typography
                            onClick={handleConfirmPasswordToggle}
                            sx={{
                                cursor: "pointer",
                                color: "#185CB7",
                                fontSize: "15px",
                                fontWeight: 600,
                                transition: "color 0.2s ease-in-out",
                                textDecoration: "none",
                            }}
                            >
                            {showConfirmPassword ? "Hide" : "Show"}
                        </Typography>
                    </InputAdornment>
                ),
                sx: { 
                    borderRadius: "10px",
                    height: 45,
                    fontSize: "16px",
                    fontWeight: confirmPassword ? "600" : "400",
                    "& input::-ms-reveal, & input::-ms-clear": {
                        display: "none",
                    },
                },
              }}
              autoComplete="off"
            />

            {!! errors.confirmPassword && (
                <Typography
                sx={{
                    color: "#FF6666",
                    fontSize: "12px",
                    mt: 0.5,
                    mb: 0,
                    marginRight: "auto"
                }}
                >
                {helperText.confirmPassword}
                </Typography>
            )}

            <Button
              disabled={loading}
              variant="contained"
              sx={{
                mt: 3,
                width: '100%',
                height: 45,
                color: "#fff",
                background: "#185CB7",
                textTransform: "none",
                fontSize: "16px",
                borderRadius: "10px",
                fontWeight: "600",
                "&:hover": { background: "#185CB7" },
              }}
              onClick={handleSubmit}
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: "#fff" }} />
              ) : (
                "Reset Password"
              )}
            </Button>

            <Typography
              sx={{
                  mt: 2,
                  fontSize: "16px",
                  color: "#00000",
                  cursor: "pointer",
                  fontWeight: 600,
                  transition: "color 0.2s ease-in-out",
                  "&:hover": { color: "#185CB7",
                    textDecoration: "underline", }
              }}
              onClick={() => navigate("/login")}
              >
              Forget it, I just remembered
              </Typography>
          </Paper>
        </Grid>
      </Grid>
      <BottomImage />
    </>
  );
};

export default NewPasswrod;
